<template>
  <div id="protocol">
    <Pheader></Pheader>
    <div class="banner"></div>
    <div class="content">
      <div class="news-detail">
        <div class="news-content-title">{{title}}</div>
        <!-- <div class="news-content-date">{{date}}</div> -->
        <pre v-html="content" class="detail-cont"></pre>
      </div>
    </div>
  </div>
</template>

<script>
import Pheader from "@/components/pc/Head";
import { protocolDetail } from "@/proxy/index"
import { mapState } from "vuex";
import { isPc } from "@/util/index"

export default {
  components: {
    Pheader,
  },
  data() {
    return {
      content: "",
      title: "",
      date: '',
    };
  },
  computed: {
    ...mapState(["_myData"])
  },
  created () {

      window.scrollTo({
        top: 0,
      });
      protocolDetail(this.$route.query.id).then(res => {
        if (res.data.code == 0) {
          const data = res.data.data
          this.content = data.content
        }
      })
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/views/protocol.scss";
</style>
